<template>
  <client-only>
    <WebccLink
      v-if="useStorageReady()"
      class="relative h-fit flex rounded border border-bgr-300 p-2 text-sm text-txt-strongest duration-200 hover:bg-bgr-100 focus:outline-none cursor-pointer"
      @click="handleClick"
    >
      <WebccIcon class="h-5 w-5 text-bgr-600" name="site/bookmark" filled />
      <span
        class="text-nowrap"
        :class="{ [`hidden ${minimize}:block ${minimize}:ml-1`]: minimize }"
      >
        {{ $t(`${trPrefix}favorites`) }}
      </span>
      <div
        v-show="bookmarks.count"
        class="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-thm text-xs text-bgr"
      >
        {{ bookmarks.count }}
      </div>
    </WebccLink>
  </client-only>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.site.Header.labels.'

defineProps<{ minimize?: ScreenSize }>()

const { buildBookmarksUrl } = useURLs()
const bookmarks = useBookmarks()
const route = useRoute()

async function handleClick() {
  await navigateToBookmarks()
}

async function navigateToBookmarks() {
  await navigateTo(
    { path: buildBookmarksUrl(), query: { ...route.query } },
    { external: true },
  )
}
</script>
